var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11975",
    "data-name": "Rectangle 11975",
    width: 27,
    height: 20.915,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_discord",
    transform: "translate(2205 20835)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11976",
    "data-name": "Rectangle 11976",
    width: 36,
    height: 36,
    transform: "translate(-2205 -20835)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "discord-color-seeklogo.com-2",
    transform: "translate(-2202 -20827.459)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32296",
    "data-name": "Path 32296",
    d: "M22.857,2.118a22.265,22.265,0,0,0-5.5-1.7.083.083,0,0,0-.088.042,15.51,15.51,0,0,0-.684,1.406,20.555,20.555,0,0,0-6.173,0A14.225,14.225,0,0,0,9.721.455.087.087,0,0,0,9.632.413a22.2,22.2,0,0,0-5.5,1.7.079.079,0,0,0-.036.031A22.787,22.787,0,0,0,.112,17.517a.093.093,0,0,0,.035.063,22.39,22.39,0,0,0,6.742,3.408.087.087,0,0,0,.095-.031,16,16,0,0,0,1.379-2.243.085.085,0,0,0-.047-.119,14.745,14.745,0,0,1-2.106-1,.087.087,0,0,1-.009-.144c.142-.106.283-.216.418-.328a.084.084,0,0,1,.087-.012,15.967,15.967,0,0,0,13.569,0,.083.083,0,0,1,.088.011c.135.111.277.223.419.329a.087.087,0,0,1-.007.144,13.836,13.836,0,0,1-2.107,1,.086.086,0,0,0-.046.12A17.968,17.968,0,0,0,20,20.956a.086.086,0,0,0,.095.032,22.315,22.315,0,0,0,6.753-3.408.087.087,0,0,0,.035-.062A22.638,22.638,0,0,0,22.892,2.15.069.069,0,0,0,22.857,2.118ZM9.023,14.449A2.6,2.6,0,0,1,6.6,11.728,2.581,2.581,0,0,1,9.023,9.007a2.567,2.567,0,0,1,2.426,2.721A2.581,2.581,0,0,1,9.023,14.449Zm8.972,0a2.6,2.6,0,0,1-2.426-2.721,2.581,2.581,0,0,1,2.426-2.721,2.567,2.567,0,0,1,2.427,2.721A2.574,2.574,0,0,1,17.994,14.449Z",
    transform: "translate(0 -0.255)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon_discord.2108449d197e13ffa5f26649b625bd71.svg";
export { ForwardRef as ReactComponent };